/**
 * @module analyticsManager
 */
// Import made to reuse web analytics manager code.
import { default as analyticsManager } from "../../web/manager/analytics";

export const analytics = {
  ...analyticsManager,
  async setAppDimensions() {
    // TODO: extract platform and year requests to a common place to avoid
    // having to call an async method everytime. That could be used in this manager,
    // as well as in mediaListsHeartbeat and reports.
    const appDevice = await this.systemManager.device.getPlatform();
    const appConfig = {
      appName: this.appName,
      appId: appDevice,
      appVersion: this.publicVersion,
      hostname: appDevice
    };
    this.set(appConfig);
  }
};
